export default __webpack_public_path__ + "static/media/ventilador-bf.f4fa9f42.jpeg";